import React, { useState } from "react";
import { FounderWithFile } from "../../containers/edit-team/TeamProfileEditComponent";
import "./styles.scss";
import defaultImage from "../../../../../../shared/resources/generic-user-profile-image.png";
import { MdClose } from "react-icons/md";

interface IProps {
  founder: FounderWithFile;
  onChange: (founder: FounderWithFile) => void;
  onClose: (founder: FounderWithFile) => void;
}

const FounderForm = (props: IProps) => {
  const [fileInput, setFileInput] = useState<any>(null);
  return (
    <div className="founder-form-wrapper">
      <div className="close-icon">
        <MdClose
          onClick={() => {
            props.onClose(props.founder);
          }}
        />
      </div>
      <div className="fimage">
        <div
          style={
            props.founder.imageError !== ""
              ? { borderColor: "red" }
              : { borderColor: "#ccc" }
          }
        >
          <img
            src={
              props.founder.imagePreview ||
              props.founder.imageUrl ||
              defaultImage
            }
            alt=""
          />
          <label style={{ marginBottom: "2px" }} className="error-message">
            {props.founder.imageError}
          </label>
          <button
            onClick={() => {
              if (fileInput) fileInput.click();
            }}
          >
            Open Image
          </button>
          <input
            ref={(input) => setFileInput(input)}
            className="d-none"
            type="file"
            accept="image/*"
            onChange={(e) => {
              const files = e.target.files;
              if (files) {
                try {
                  let reader = new FileReader();
                  let file = files[0];
                  reader.onloadend = () => {
                    props.onChange({
                      ...props.founder,
                      file,
                      imagePreview: reader.result,
                      imageError: "",
                    });
                  };
                  reader.readAsDataURL(file);
                } catch (error) { }
              }
            }}
          />
        </div>
      </div>
      <div className="fdetails">
        <div>
          <label>
            <strong>Title</strong>
          </label>
          <span style={{ color: "red" }}>*</span>
          <input
            value={props.founder.title || ""}
            onChange={(e) => {
              props.onChange({
                ...props.founder,
                title: e.target.value,
                titleError: "",
              });
            }}
            className={
              props.founder.titleError.length < 1
                ? "app-input"
                : "app-input-profile invalid"
            }
          />
          <label style={{ marginBottom: "2px" }} className="error-message">
            {props.founder.titleError}
          </label>
        </div>
        <div>
          <label>
            <strong>Name</strong>
          </label>
          <span style={{ color: "red" }}>*</span>
          <input
            value={props.founder.name || ""}
            onChange={(e) => {
              props.onChange({
                ...props.founder,
                name: e.target.value,
                nameError: "",
              });
            }}
            className={
              props.founder.nameError.length < 1
                ? "app-input"
                : "app-input-profile invalid"
            }
          />
          <label style={{ marginBottom: "2px" }} className="error-message">
            {props.founder.nameError}
          </label>
        </div>
        <div>
          <label>
            <strong> Description</strong>
          </label>
          <span style={{ color: "red" }}>*</span>
          <textarea
            value={props.founder.description || ""}
            onChange={(e) => {
              props.onChange({
                ...props.founder,
                description: e.target.value,
                descriptionError: "",
              });
            }}
            className={
              props.founder.descriptionError.length < 1
                ? "app-input"
                : "app-input-profile invalid"
            }
          />
          <label style={{ marginBottom: "2px" }} className="error-message">
            {props.founder.descriptionError}
          </label>
        </div>
      </div>
    </div>
  );
};

export default FounderForm;
